export default __webpack_public_path__ + "static/media/features_right_bg.e8dcd366.svg";